/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// import Slide from "@material-ui/core/Slide";
import Tooltip from "@material-ui/core/Tooltip";
import Close from "@material-ui/icons/Close";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Table from "components/Table/Table.js";
import SweetAlert from "react-bootstrap-sweetalert";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import BanglesHeader from "views/BanglesPage/Section/BanglesHeader";
import BanglesHeaderLink from "views/BanglesPage/Section/BanglesHeaderLink";
import BanglesFooter from "views/BanglesPage/Section/BanglesFooter";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

const useStyles = makeStyles(profilePageStyle);
const useStylesTable = makeStyles(invoiceStyle);
const useStyleCart = makeStyles(listCart);
const useStyleAlert = makeStyles(style);

export default function AddCart({ ...rest }) {
  const [addCart, setAddCart] = React.useState([]);
  const [userId, setUserId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);
  const [cardId, setCartId] = React.useState();
  const [load, setLoad] = React.useState(false);

  const classes = useStyles();
  const history = useHistory();

  const classesTable = useStylesTable();
  const classeCart = useStyleCart();
  const classeAlert = useStyleAlert();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const date = Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).format(new Date()).replaceAll('/', '-');

  const current = new Date();
  const dateCurrent = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
  current.setDate(current.getDate() + 10);
  let dateEx = new Date(current).toLocaleDateString("de");

  async function getList() {
    const get = headApi + `/user/${userObj && userObj.mobile}`;
    const results = await fetch(get);
    const res = await results.json();
    if (res.message === "Mobile Number Not Found") {
      history.push("/");
    }
    setUserId(res.id);
    // const list = headApi + `/cart/byClientid?userid=${res.referenceid}&clientid=${res.id}`
    const list = headApi + `/cart/byInterval?userid=1&clientid=${res.id}`
    const result = await fetch(list);
    const data = await result.json();
    if (data.error === "true") {
      setLoad(false)
      history.push("/error-page");
    } else {
      setLoad(true)
      // setAddCart(data.CartData)
      setAddCart(data && data.CartData ? data.CartData : history.push("/error-page"));
    }
    // setAddCart(data && data.CartData ? data.CartData : history.push("/"));
  }

  useEffect(() => {
    getList();
  }, []);

  const handleitemRemove = (c, submitted) => {
    setSubmitted(true)
  }

  const handleConfirm = () => {
    // console.log(cardId);
    axios.delete(headApi + `/cart?id=${cardId}&clientid=${userId}`)
      .then(res => {
        // console.log(res.data);
        // if (res.message === "Data Deleted Successfully!!! ") {
        //   setSubmittedConfirm(true)
        // window.location.reload(false);
        // }
      })
    setSubmittedConfirm(true)
  };

  const hideAlert = () => {
    setSubmitted(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  var totalCal = 0;
  var totalCalMix = 0;
  var totalSum = 0;

  return (
    <div>
      <Helmet>
        <title>Add Cart</title>
      </Helmet>
      {load ? <>
      <BanglesHeader
        color="info"
        brand="Home"
        links={<BanglesHeaderLink dropdownHoverColor="info" />}
        fixed
        // changeColorOnScroll={{
        //     height: 200,
        //     color: "info",
        // }}
        {...rest}
      />
      <Parallax
        image={require("assets/img/bg6.jpg").default}
        filter="info"
        className={classes.parallax}
      >

      </Parallax>
      <div className={classNames(classeCart.main, classeCart.mainRaised)}>
        <div className={classeCart.container}>
          {submitted ? (
            <SweetAlert
              warning
              style={{ display: "block", marginTop: "100px" }}
              title="Are you sure?"
              onConfirm={handleConfirm}
              onCancel={() => hideAlert()}
              confirmBtnCssClass={
                classeAlert.button + " " + classeAlert.success
              }
              cancelBtnCssClass={classeAlert.button + " " + classeAlert.danger}
              confirmBtnText="Yes, delete it!"
              cancelBtnText="Cancel"
              showCancel
            />
          ) : null}

          {submittedConfirm ? (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "100px" }}
              title="Deleted!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
            >
              Your imaginary file has been deleted.
            </SweetAlert>
          ) : null}
          <Card plain>
            <CardBody plain>
              <h3 className={classeCart.cardTitle}>My Cart</h3>
              <Table
                tableHead={[
                  <span className={classesTable.tableHead} key="sr">
                    Sr.
                    <br />
                    No.
                  </span>,
                  "",
                  <span className={classesTable.tableHead} key="des">Description of Goods</span>,
                  <span className={classesTable.tableHead + " " + classesTable.headRight} key="qty">
                    Quantity
                  </span>,
                  <span className={classesTable.tableHead + " " + classesTable.headRight} key="pri">
                    Price
                  </span>,
                  <span className={classesTable.tableHead + " " + classesTable.headRight} key="amt">
                    Amount
                  </span>,
                  "",
                ]}
                tableData={[
                  ...addCart.map((c, index) => (
                    [
                      <span className={classesTable.listNumber} key={c.id}>{index + 1}</span>,
                      <div className={classeCart.imgContainer} key={c.id}>
                        {/* Date: {c.timedate.date.slice(0, -12)} */}
                        Date: {new Date(c.timedate.date).toLocaleDateString("de")}
                        {c.design1.img1active === 1 ? (
                          <img
                            src={imgApi + "" + c.design1.image1}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design2.img2active === 1 ? (
                          <img
                            src={imgApi + "" + c.design2.image2}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design3.img3active === 1 ? (
                          <img
                            src={imgApi + "" + c.design3.image3}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design4.img4active === 1 ? (
                          <img
                            src={imgApi + "" + c.design4.image4}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design5.img5active === 1 ? (
                          <img
                            src={imgApi + "" + c.design5.image5}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design6.img6active === 1 ? (
                          <img
                            src={imgApi + "" + c.design6.image6}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : (
                          ""
                        )}
                      </div>,
                      <span key={c.id}>
                        <small className={classesTable.listDescription}>
                          {c.platingList.description.slice(8)} {c.cat.description}{" "}
                          {c.catSize.description}{" / Card id "}{c.id}
                        </small>
                        <br />
                        <small className={classesTable.listDescriptions}>
                          Packing : {c.packing.type}
                        </small>
                        <br />
                        <small className={classesTable.listDescriptions}>
                          {(
                            c.metalOption.readygram * c.sets.pcs +
                            (c?.mixmmList
                              ? c.mixmmList
                                .map((mix) => mix.sets.pcs)
                                .reduce((a, b) => a + b, 0) *
                              c.mixmmList
                                .map((mix) => mix.metalOption.readygram)
                                .reduce((a, b) => a + b, 0)
                              : 0)
                          ).toFixed(4)}{" "}
                          Avg Gram of{" "}
                          {c.sets.pcs +
                            (c?.mixmmList
                              ? c.mixmmList
                                .map((mix) => mix.sets.pcs)
                                .reduce((a, b) => a + b, 0)
                              : 0)}{" "}
                          {c.sets.setdesc.slice(2)}
                        </small>
                        <br />
                        <small className={classesTable.listDescription}>
                          Sets Price :{" "}
                          {c.taxCalculation.cash_gst === 0
                            ? (c.taxCalculation.cash / c.box.box).toFixed(2)
                            : (c.taxCalculation.taxincl / c.box.box).toFixed(2)}
                          /-{" "}
                        </small>
                        <br />
                        <small className={classesTable.listDescriptions}>
                          Metal Rate : ₹ {c.metal.price}/- Advance : ₹{Math.round(c.metalOption.metalgram * c.sets.pcs * c.box.box * c.total * c.metal.price + (c.mixmmList && c.mixmmList ? c.mixmmList.map((m) => m.metalOption.metalgram * m.sets.pcs * m.metal.price).reduce((a, b) => a + b, 0) * c.box.box * c.total : ""))}
                          /-
                        </small>
                        <br />

                        <GridContainer className={classesTable.sizePadding}>
                          {c.stocksizes._1x8 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x8 === null
                                ? ""
                                : c.stocksizes._1x8 === 0
                                  ? ""
                                  : "1x8"}
                              <br />
                              {c.stocksizes._1x8 === null
                                ? ""
                                : c.stocksizes._1x8 === 0
                                  ? ""
                                  : c.stocksizes._1x8}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._1x10 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x10 === null
                                ? ""
                                : c.stocksizes._1x10 === 0
                                  ? ""
                                  : c.indiasize === 1
                                    ? "1x10"
                                    : "#1"}
                              <br />
                              {c.stocksizes._1x10 === null
                                ? ""
                                : c.stocksizes._1x10 === 0
                                  ? ""
                                  : c.stocksizes._1x10}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._1x12 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x12 === null ? (
                                ""
                              ) : c.stocksizes._1x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "1x12" : "#2"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._1x12 === null ? (
                                ""
                              ) : c.stocksizes._1x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._1x12}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._1x14 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x14 === null ? (
                                ""
                              ) : c.stocksizes._1x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  1x14
                                </span>
                              )}
                              <br />
                              {c.stocksizes._1x14 === null ? (
                                ""
                              ) : c.stocksizes._1x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._1x14}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x0 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x0 === null ? (
                                ""
                              ) : c.stocksizes._2x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x0" : "#3"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x0 === null ? (
                                ""
                              ) : c.stocksizes._2x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x0}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x2 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x2 === null ? (
                                ""
                              ) : c.stocksizes._2x2 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  2x2
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x2 === null ? (
                                ""
                              ) : c.stocksizes._2x2 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x2}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x4 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x4 === null ? (
                                ""
                              ) : c.stocksizes._2x4 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x4" : "#4"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x4 === null ? (
                                ""
                              ) : c.stocksizes._2x4 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x4}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x6 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x6 === null ? (
                                ""
                              ) : c.stocksizes._2x6 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  2x6
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x6 === null ? (
                                ""
                              ) : c.stocksizes._2x6 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x6}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x8 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x8 === null ? (
                                ""
                              ) : c.stocksizes._2x8 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x8" : "#5"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x8 === null ? (
                                ""
                              ) : c.stocksizes._2x8 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x8}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x10 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x10 === null ? (
                                ""
                              ) : c.stocksizes._2x10 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x10" : "#6"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x10 === null ? (
                                ""
                              ) : c.stocksizes._2x10 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x10}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x12 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x12 === null ? (
                                ""
                              ) : c.stocksizes._2x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x12" : "#7"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x12 === null ? (
                                ""
                              ) : c.stocksizes._2x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x12}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x14 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x14 === null ? (
                                ""
                              ) : c.stocksizes._2x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  2x14
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x14 === null ? (
                                ""
                              ) : c.stocksizes._2x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x14}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._3x0 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._3x0 === null ? (
                                ""
                              ) : c.stocksizes._3x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "3x0" : "#8"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._3x0 === null ? (
                                ""
                              ) : c.stocksizes._3x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._3x0}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                        </GridContainer>
                        <span className={classesTable.listDescription}>{c && c.name ? c.name + ", " : ""} {c && c.mycomment ? c.mycomment : ""}</span>
                      </span>,
                      <span
                        className={classesTable.headRight + " " + classesTable.listNumber}
                        key={c.id}
                      >
                        {c.total}
                      </span>,
                      <span
                        className={classesTable.headRight + " " + classesTable.listNumber}
                        key={c.id}
                      >
                        ₹
                        {c.taxCalculation.cash_gst === 0
                          ? c.taxCalculation.cash
                          : c.taxCalculation.taxincl}
                      </span>,
                      <span
                        className={classesTable.headRight + " " + classesTable.listNumber}
                        key={c.id}
                      >
                        ₹{Math.round(c.taxableamt)}
                      </span>,
                      <Tooltip
                        id="close1"
                        title="Cart Remove"
                        placement="left"
                        classes={{ tooltip: classeCart.tooltip }}
                        key={c.id}
                      >
                        <Button
                          link
                          className={classeCart.actionButton}
                          onClick={() => {
                            handleitemRemove(c.id);
                            setCartId(c.id);
                          }}
                        >
                          <Close style={{ color: "red" }} />
                        </Button>
                      </Tooltip>,
                    ]
                  )),
                  [
                    "",
                    <span className={classesTable.listNumber} key={1}>Cartoon Charges<br />Grand Total</span>,
                    <span className={classesTable.listNumber} key={2}><br />
                    {addCart.map((c) => {
                        totalCal = totalCal + c.metalOption.metalgram * c.sets.pcs * c.box.box * c.total * c.metal.price;
                        // totalSum = totalCal + totalCalMix;
                        return (
                          c.mixmmList && c.mixmmList ? c.mixmmList.map((m) => {
                            totalCalMix = totalCalMix + m.metalOption.metalgram * m.sets.pcs * m.metal.price * c.box.box * c.total;
                            totalSum = totalCal + totalCalMix;
                            return (
                              ""
                            )
                          }) : ""
                        )
                      })}
                      Advance - ₹{Math.round(totalSum = totalCalMix + totalCal) + "/-"}</span>,
                    <span key={3}>
                      <span className={classesTable.headRight}>CRTN-{addCart.reduce((a, b) => parseInt(a) + parseInt(b.ctnquantity), 0)}</span><br />
                      <span className={classesTable.headRight + " " + classesTable.listNumber}>Box-{addCart && addCart.reduce((a, b) => a + b.total, 0)}</span>
                    </span>,
                    "",
                    <span key={4}>
                      <span className={classesTable.headRight + " " + classesTable.listNumber}>₹{addCart.reduce((a, b) => a + b.totalcartoncharge, 0) + "/-"}</span><br />
                      <span className={classesTable.headRight + " " + classesTable.listNumber}>₹{Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)) + "/-"}</span>
                    </span>,
                    ""
                  ]
                ]}
              />
              <hr />
              <Button style={{ float: "right", marginTop: "15px", marginBottom: "15px" }} color="info" round href="/cart-shipping-address">Proceed Order</Button>
            </CardBody>
          </Card>
        </div>
      </div>
      <BanglesFooter />
      </> : "" }
    </div>
  );
}